import React, { useEffect } from 'react';

import PropTypes from 'prop-types';

import { useEditor, useNode } from '@craftjs/core';

import { useBorder } from '@common/providers/BorderProvider/BorderProvider';
import {
  addDeleteButton,
  getPos,
  createIndicatorDiv,
  createNameDiv,
  stateSelector,
  addDeleteStyles,
  removeDeleteStyles,
  addGridStyles,
  removeGridStyles,
  removeSelectionStyles,
  isDomButton,
  addButtonSelectionStyles,
  addComponentSelectionStyles,
  updateElementPosition,
  addListenerToCraftEditor,
  removeListenerFromCraftEditor,
} from '@common/helpers/domManipulationHelpers';

(function ensureIconBtnStyles() {
  if (document.getElementById('icon-btn-styles')) return;
  const style = document.createElement('style');
  style.id = 'icon-btn-styles';
  style.textContent = `
    .icon-btn {
      --base-color: currentColor;
      --icon-color: color-mix(in oklab, var(--base-color) 88%, black);
      --icon-color-hover: color-mix(in oklab, var(--base-color) 70%, black);

      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 30px; height: 30px;
      
      border: none;
      border-radius: 8px;
      background: transparent;
      color: inherit;
      cursor: pointer;
    }
    .icon-btn svg {
      width: 30px; height: 30px;
      fill: var(--icon-color);
     
      pointer-events: none;
    }
    .icon-btn:hover svg { fill: var(--icon-color-hover); }
  
   
    @supports not (color: color-mix(in oklab, red 50%, black)) {
      .icon-btn svg { filter: brightness(0.85); }
      .icon-btn:hover svg { filter: brightness(0.7); }
    }
  `;
  document.head.appendChild(style);
})();

const RenderNode = ({ render }) => {
  const { showBorders, cellsForDelete } = useBorder();
  const { actions } = useEditor();
  const { isActive, isHover, dom, name, id, isDeletable } =
    useNode(stateSelector);

  useEffect(() => {
    let indicatorEl;
    let hoverStyle;
    let indicatorDelete;

    if (cellsForDelete && cellsForDelete?.includes(id)) {
      indicatorDelete = true;
      addDeleteStyles(dom);
    } else {
      removeDeleteStyles(dom);
    }

    if (showBorders) {
      addGridStyles(dom);
    } else {
      removeGridStyles(dom);
    }

    if (!dom || !(isActive || isHover) || indicatorDelete) {
      removeSelectionStyles(dom);
      return;
    }

    if (isDomButton(dom)) {
      hoverStyle = addButtonSelectionStyles();
    } else {
      hoverStyle = addComponentSelectionStyles();
    }

    dom?.classList.add(hoverStyle);

    indicatorEl = createIndicatorDiv();
    let nameEl = createNameDiv(name);

    if (isDeletable) {
      addDeleteButton(nameEl, actions, id);
    }

    const updateIndicatorPosition = () => {
      const rect = getPos(dom);
      if (rect) {
        updateElementPosition(indicatorEl, rect);
      }
    };

    updateIndicatorPosition();

    indicatorEl.appendChild(nameEl);
    document.body.appendChild(indicatorEl);

    addListenerToCraftEditor(updateIndicatorPosition);

    return () => {
      removeListenerFromCraftEditor(updateIndicatorPosition);

      if (indicatorEl) {
        document.body.removeChild(indicatorEl);
      }
    };
  }, [dom, isActive, isHover, showBorders, cellsForDelete]);

  return <>{render}</>;
};

RenderNode.propTypes = {
  render: PropTypes.element.isRequired,
};

export default RenderNode;
